import { ApiPrice } from '@ibe/api';
import { PriceFactory } from '@ibe/services';
import { differenceInCalendarDays } from 'date-fns';

export const getPricePerNight = (totalPrice: ApiPrice, nights: number): ApiPrice => {
  if (!totalPrice.finalPrice || nights < 2) return totalPrice;
  return PriceFactory.create(totalPrice.finalPrice / nights, totalPrice.currencyCode);
};

export const calculateNights = (startDate: string, endDate: string): number => {
  return differenceInCalendarDays(new Date(endDate), new Date(startDate));
};
